module.exports = __webpack_public_path__ + "img/phone.42de9e24.svg";